import { Descendant, Editor, Transforms } from "slate";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";
import userDisplayName from "@mapmycustomers/shared/util/formatters/userDisplayName";

import { MentionElement } from "../../../../../type/slate-types";
import ElementType from "../../../../../type/slate/ElementType";
import IsMentionDisabled from "../type/IsMentionDisabled";
import MentionType from "../type/MentionType";

const insertMention = (
  editor: Editor,
  user: undefined | User,
  team: Team | undefined,
  type: MentionType,
  isMentionDisabled?: IsMentionDisabled
) => {
  const mention = type === MentionType.USER ? user : team;

  if (!mention) {
    return;
  }

  const insert: Descendant[] = [
    {
      children: [{ text: "" }],
      disabled:
        isMentionDisabled && "username" in mention
          ? isMentionDisabled(mention)
          : mention.deletedAt
            ? true
            : false,
      email: "username" in mention ? (mention.username ?? "") : "",
      name: "username" in mention ? userDisplayName(mention) : mention.name,
      teamId: type === MentionType.TEAM ? mention.id : undefined,
      type: ElementType.MENTION,
    } as MentionElement,
    { text: " " },
  ];
  Transforms.insertNodes(editor, insert, { select: true });
  Transforms.move(editor, { edge: "end" });
};

export default insertMention;
